import LoadingDots from "./ui/LoadingDots";

export default function Loader() {
    return (
        <div className="flex flex-col items-center justify-center py-8">
            <LoadingDots size="md" className="mb-3 py-0" />
            <p className="text-sm text-neutral-500 dark:text-neutral-400">Loading...</p>
        </div>
    );
}
